import AuthFormLayout from "./AuthFormLayout.styled";

export default AuthFormLayout;
